// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.twowaytext.UpdateTwoWayTextConversationPatientRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateTwoWayTextConversationPatientRequest extends GandalfModelBase {

	@GandalfLabel('Connect Conversation')
	@GandalfValidator({ notNull: { message: 'Connect Conversation is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	connectConversationId!: number;

	@GandalfLabel('Patient')
	@GandalfProperty({ designType: Number })
	patientId!: number | null;

}
